module.exports = __webpack_public_path__ + "static/img/cyBanner@2x.9f913d05.png";